import EnergyDashboard from "./pages/EnergyDashboard";
import LoginForm from "./pages/LoginForm";
import RegisterForm from "./pages/RegisterForm";
import WalletLogin from "./pages/WalletLogin";
import LinkWallet from "./pages/LinkWallet";
import EnergyMarketplace from "./pages/EnergyMarketplace";
import DeviceAndAgreementRegistry from "./pages/DeviceAndAgreementRegistry";
import Agreement from "./pages/Agreement";
// import {Home} from "./components/Home";

const AppRoutes = [
    {
        index: true,
        element: <EnergyMarketplace/>
    },
    {
        path: '/dashboard',
        element: <EnergyDashboard/>
    },
    {
        path: '/login',
        element: <LoginForm/>
    },
    {
        path: '/register',
        element: <RegisterForm/>
    },
    {
        path: '/wallet-login',
        element: <WalletLogin/>
    },
    {
        path: '/link-wallet',
        element: <LinkWallet/>
    },
    {
        path: '/energy-marketplace',
        element: <EnergyMarketplace/>
    },
    {
        path: '/device-agreement-registry',
        element: <DeviceAndAgreementRegistry/>
    },
    {
        path: '/agreement',
        element: <Agreement/>
    }
];

export default AppRoutes;
